module.exports = __webpack_public_path__ + "static/media/DSC_2922.01b9958c.jpg";